export default __webpack_public_path__ + "static/media/monpharmacien.aaaf327d.svg";